export { ConnectedProductsStore } from './ConnectedProductsStore';

import { ConnectedProductsStoreAll } from './ConnectedProductsStoreAll';
import { ConnectedProductsStoreOrganization } from './ConnectedProductsStoreOrganization';

export default {
    connectedProductsStoreAll: new ConnectedProductsStoreAll(),
    connectedProductsStoreOrganization: new ConnectedProductsStoreOrganization()
};
